import {
  ProgramCodeBook,
  ProgramType,
  ProgramTypeCodeBook,
} from "../../models/Program";
import { ProgramRequestData } from "../../models/ProgramRequest";
import { ProgramRequestDetail, ProgramRequestDetailBase } from "../../models/ProgramRequest/ProgramRequestDetail";
import { BasicEducationProgramInfo } from "./BasicEducationProgramInfo";
import { ExpertiseExistingProgramInfo } from "./ExpertiseExistingProgramInfo";
import { ExpertiseNewProgramInfo } from "./ExpertiseNewProgramInfo";
import { ForeignLanguageProgramInfo } from "./ForeignLanguageProgramInfo";
import { MiddleSchoolProgramInfo } from "./MiddleSchoolProgramInfo";

interface Props {
  programTypeId: number;
  programData?: ProgramCodeBook;
  programRequestData?: ProgramRequestData;
  programRequestDetail?: ProgramRequestDetail;
  programRequestDetailChange?: ProgramRequestDetail;
  readonly?: boolean;
  onChange: (e: any) => void;
  errors: any;
}

/** Renders several rows of qualification, hkoLevel, sector, 
 * and profession info based on programTypeId and programData.
 */
export function ConditionalBasicInfo({
  programTypeId,
  programData,
  programRequestData = undefined,
  programRequestDetail = undefined,
  programRequestDetailChange = undefined,
  readonly = false,
  onChange,
  errors
}: Props) {
  if (
    (programTypeId === ProgramType.ForeignLanguageLearningPrograms || programTypeId === ProgramType.CroatianLanguageForForeigners) && programData
  ) {
    return (
      <ForeignLanguageProgramInfo
        programData={programData}
        programRequest={programRequestData !== undefined ? programRequestData! : programRequestDetail!}
        programRequestChange={programRequestDetailChange}
        onChange={onChange}
        errors={errors}
        readonly={readonly}
      />
    );
  } else if (
    (
      programTypeId === ProgramType.MiddleSchoolShorterThanThreeYearsPrograms ||
      programTypeId === ProgramType.MiddleSchoolThreeYearsPrograms ||
      programTypeId === ProgramType.MiddleSchoolLongerThanThreeYearsPrograms
    ) && programData
  ) {
    return (
      <MiddleSchoolProgramInfo
        programData={programData}
      />
    );
  } else if (
    (
      programTypeId === ProgramType.BasicEducationPrograms ||
      programTypeId === ProgramType.BasicArtsPrograms ||
      programTypeId === ProgramType.MiddleSchoolArtsProgramsLongerThanThreeYears
    ) && programData
  ) {
    return (
      <BasicEducationProgramInfo
        programTypeId={programTypeId}
        programData={programData}
      />
    );
  } else if (
    (
      programTypeId === ProgramType.TrainingPrograms ||
      programTypeId === ProgramType.CraftsAndArtsTrainingPrograms ||
      programTypeId === ProgramType.CraftsSpecializationPrograms ||
      programTypeId === ProgramType.RefinementPrograms      
    ) && !programData
  ) {
    return (
      <ExpertiseNewProgramInfo
        programTypeId={programTypeId}
        programRequestData={programRequestData}
        programRequestDetail={programRequestDetail}
        onChange={onChange}
        errors={errors}
        readonly={readonly}
      />
    );
  } else if (
    (
      programTypeId === ProgramType.TrainingPrograms ||
      programTypeId === ProgramType.CraftsAndArtsTrainingPrograms ||
      programTypeId === ProgramType.CraftsSpecializationPrograms ||
      programTypeId === ProgramType.RefinementPrograms ||      
      programTypeId === ProgramType.NewVocationalCurriculum
    ) && programData
  ) {
    return (
      <ExpertiseExistingProgramInfo
        programData={programData}
      />
    );
  } else {
    return <></>;
  }
}
